import * as Yup from "yup";
import BackIcon from "../../icons/backIcon";
import { getCodeData } from "../../services/Code/sendCodeSlice";
import { varifyCodeData } from "../../services/Code/codeVerifySlice";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useRef, useEffect, useContext } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { FaRegKeyboard } from "react-icons/fa";
import { Bounce, toast } from "react-toastify";
// import { getOrderDoneData } from "../services/orderSlice";
import VerificationHeader from "../../components/verificationHeader";
import { getOrderIdData } from "../../services/Order/orderIdSlice";
import { getOrderDoneData } from "../../services/Order/orderSlice";
import Spinner from "../../components/spinner";
import { IoMdClose } from "react-icons/io";
import { sendPicture } from "../../services/Code/sendPictureSlice";
import { useImageContext } from "../../contexts/ImageContext";
import { updateReservation } from "../../services/Order/reservationSlice";
import { updateEcommIdThunk } from "../../services/Order/updateEcommIdSlice";
import AutoNavigatePopup from "../../components/AutoNavigatePopup";
import { ServiceSearchQueryContext } from "../../contexts/ServiceSearchQueryContext";
import { EmployeesContext } from "../../contexts/EmployeesContext";
// import { sendNotification } from "../../services/Code/sendNotificationSlice";
// import { sendNotification } from "../../services/api/code";

const OTBSchema = Yup.object().shape({
  otp1: Yup.string()
    .required("Required")
    .matches(/^[0-9]$/, "Must be a number"),
  otp2: Yup.string()
    .required("Required")
    .matches(/^[0-9]$/, "Must be a number"),
  otp3: Yup.string()
    .required("Required")
    .matches(/^[0-9]$/, "Must be a number"),
  otp4: Yup.string()
    .required("Required")
    .matches(/^[0-9]$/, "Must be a number"),
});

export default function CodeVerification() {
  const dispatch = useDispatch();
  const location = useLocation();

  // const { t } = useTranslation();
  const navigate = useNavigate();
  // const [isShow, setIsShow] = useState(false);
  //
  const [otp, setOtp] = useState({ otp1: "", otp2: "", otp3: "", otp4: "" });
  const otpRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];
  const [isShowKeyboard, setIsShowKeyboard] = useState(true);
  const [timeLeft, setTimeLeft] = useState(60);
  const [isLoading, setIsLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const otp1Ref = useRef(null);
  const { capturedImage } = useImageContext();
  const cartItems = JSON.parse(sessionStorage.getItem("cartItems")) || {};
  console.log("cartItems Inside Code Verification", cartItems);
  const {
    // searchQuery,
    setSearchQuery,

    // currentPage,
    // setCurrentPage,
    // debouncedSearchQuery,
    // setDebouncedSearchQuery,
  } = useContext(ServiceSearchQueryContext);
  const { handleGetEmployees } = useContext(EmployeesContext);
  // console.log("capturedImage", capturedImage);
  const previousLocation = location.state.from;
  // console.log(previousLocation, "previousLocation");

  const parentLocation = location.state.previousLocation;
  // console.log(parentLocation, "parentLocation");

  if (
    capturedImage &&
    (capturedImage.startsWith("data:image/jpeg") ||
      capturedImage.startsWith("data:image/png"))
  ) {
    console.log("This is a valid image.");
  } else {
    console.error("The captured data is not a valid image.");
  }
  // console.log("previousLocation", previousLocation);
  // console.log("parentLocation", parentLocation);
  const codeData = useSelector((state) => state?.sendCode?.code);
  // const codeMessage = codeData?.message;
  const verificationCode = codeData?.data?.code;
  sessionStorage.setItem("code", verificationCode);
  // const code = codeData.data.code;
  // console.log("aaa", code);
  const varifyData = useSelector((state) => state?.codeVerify?.customerId);
  const verifyStatus = varifyData?.status;
  const verifyMessage = varifyData?.message;
  // console.log(verifyMessage);
  // console.log("varifyData", varifyData);
  // console.log("verifyStatus", verifyStatus);
  // console.log("verifyStatus", verifyStatus);
  const { data: businessData } = useSelector((state) => state?.business?.data);
  const firebaseIntegrationFile =
    businessData?.integration?.firebase_service_file;

  // const orderState = useSelector((state) => state?.order);

  // const orderDone = orderState?.orderDone;
  // const reservationResponse = orderState?.reservationResponse;
  // const isLoadingOrder = orderState?.isLoading;
  // const isError = orderState?.isError;

  // console.log(
  //   "orderDone",
  //   orderDone,
  //   "/n reservationResponse",
  //   reservationResponse,
  //   "/n isLoadingOrder",
  //   isLoadingOrder,
  //   "/n isError",
  //   isError
  // );
  // const reservationResponse = useSelector(
  //   (state) => state.order.reservationResponse
  // );
  // const isLoadingReservation = useSelector((state) => state.order.isLoading);
  // const isErrorReservation = useSelector((state) => state.order.isError);
  // console.log("reservationResponse", reservationResponse);
  // console.log("isLoadingReservation", isLoadingReservation);
  // console.log("isErrorReservation", isErrorReservation);
  // useEffect(() => {
  //   const executeAsyncActions = async () => {
  //     try {
  //       // First dispatch
  //       await dispatch(varifyCodeData());

  //       // Second dispatch after the first one completes
  //       // await dispatch(sendNotification({ verificationCode }));
  //     } catch (error) {
  //       console.error("An error occurred during the dispatch sequence:", error);
  //     }
  //   };

  //   executeAsyncActions();
  // }, [dispatch]);
  //
  // const [showCode, setShowCode] = useState(true);
  // useEffect(() => {
  //   if (verifyMessage == "code expired") {
  //     setShowCode(false);
  //   } else {
  //     setShowCode(true);
  //   }
  // }, [verifyMessage]);
  //
  // const code = sessionStorage.getItem("code");
  //   // ===== Mask phone number with stars =====
  const phone = sessionStorage.getItem("phone");
  // console.log("phone", phone);
  // console.log("otpfoooow", otp);
  const maskPhone = (phone) => {
    if (phone) {
      const firstPart = phone.slice(0, 5);
      const lastPart = phone.slice(-2);
      return ` ${firstPart}*****${lastPart}`;
    }
    return phone;
  };
  //
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? `0${secs}` : secs}`;
  };

  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
    if (timeLeft == 0) {
      dispatch(varifyCodeData());
    }
  }, [timeLeft]);

  const handleKeyboardClick = (number) => {
    const emptyKey = Object.keys(otp).find((key) => otp[key] === "");
    if (emptyKey) {
      setOtp({ ...otp, [emptyKey]: number });
    }
  };
  //
  const handleDelete = () => {
    const filledKeys = Object.keys(otp).filter((key) => otp[key] !== "");
    const lastFilledKey = filledKeys[filledKeys.length - 1];
    if (lastFilledKey) {
      setOtp({ ...otp, [lastFilledKey]: "" });
    }
  };
  //
  useEffect(() => {
    setTimeout(() => {
      if (otp1Ref.current) {
        otp1Ref.current.focus();
      }
    }, 0);
  }, [dispatch]);
  //
  const handleOtpChange = (e, index) => {
    const { value } = e.target;
    if (value.match(/^[0-9]$/)) {
      const newOtp = { ...otp, [`otp${index + 1}`]: value };
      console.log("newOtp", newOtp);
      setOtp(newOtp);
      if (index < 3 && otpRefs[index + 1].current) {
        otpRefs[index + 1].current.focus(); // Move focus to next input if exists
      }
    } else if (value === "") {
      setOtp({ ...otp, [`otp${index + 1}`]: "" });
    }
  };
  //
  const handleKeyDown = (e, index) => {
    if (
      e.key === "Backspace" &&
      otp[`otp${index + 1}`] === "" &&
      index > 0 &&
      otpRefs[index - 1].current
    ) {
      otpRefs[index - 1].current.focus(); // Move focus to previous input if exists
    }
  };
  //
  // const success = () =>
  //   toast("Order created successfully", {
  //     style: {
  //       background: " #84cc16",
  //       color: "#fff",
  //       fontWeight: "bold",
  //       fontSize: "1.2rem",
  //       padding: "1rem",
  //     },
  //     position: "top-center",
  //     autoClose: 1750,
  //     hideProgressBar: false,
  //     pauseOnHover: true,
  //     draggable: true,
  //     progress: 0,
  //     theme: "colored",
  //     transition: Bounce,
  //   });
  //
  // const goToServicePopup = (message, service_id, employee_id) => {
  //   setPopupMessage(message);
  //   setShowPopup(true);
  //   console.log("service_id outside IF", service_id);
  //   if (service_id && employee_id) {
  //     const indexToRemove = cartItems.product_id.findIndex(
  //       (id, index) =>
  //         id === service_id && cartItems.professionals_id[index] === employee_id
  //     );
  //     if (indexToRemove !== -1) {
  //       console.log(`Matching index: ${indexToRemove}`);

  //       const updatedItems = { ...cartItems };

  //       updatedItems.product.splice(indexToRemove, 1);
  //       updatedItems.product_id.splice(indexToRemove, 1);
  //       updatedItems.product_price.splice(indexToRemove, 1);
  //       updatedItems.product_qty.splice(indexToRemove, 1);
  //       updatedItems.professionals.splice(indexToRemove, 1);
  //       updatedItems.professionals_id.splice(indexToRemove, 1);
  //       updatedItems.is_service.splice(indexToRemove, 1);

  //       // Update session storage and state
  //       sessionStorage.setItem("cartItems", JSON.stringify(updatedItems));
  //     } else {
  //       console.log("Item not found in cart.");
  //     }
  //     // console.log("w");
  //   }
  //   if (service_id) {
  //     const matchedProduct = cartItems?.product?.find(
  //       (product) => product.id === service_id
  //     );
  //     const matchedProductName = matchedProduct?.descriptions[0]?.name;
  //     console.log("service_id inside IF", matchedProduct);
  //     setTimeout(() => {
  //       // Adding a timeout to allow the page to load.

  //       handleGetEmployees(matchedProduct?.id);
  //       // setIsShow(false);
  //     }, 1000);
  //     setSearchQuery(matchedProductName);
  //   }
  // };
  const goToServicePopup = (message, service_id, employee_id) => {
    // Set the popup message and show the popup
    setPopupMessage(message);
    setShowPopup(true);

    console.log("service_id outside IF:", service_id);

    // Check if both service_id and employee_id are provided
    if (service_id && employee_id) {
      console.log("Removing item from cart...");

      // Find the index of the item to remove
      const indexToRemove = cartItems.product_id.findIndex(
        (id, index) =>
          id === service_id && cartItems.professionals_id[index] === employee_id
      );

      if (indexToRemove !== -1) {
        console.log(`Matching index: ${indexToRemove}`);

        // Create a deep copy of cartItems to avoid direct mutation
        const updatedItems = JSON.parse(JSON.stringify(cartItems));

        // Remove the item from all arrays
        updatedItems.product.splice(indexToRemove, 1);
        updatedItems.product_id.splice(indexToRemove, 1);
        updatedItems.product_price.splice(indexToRemove, 1);
        updatedItems.product_qty.splice(indexToRemove, 1);
        updatedItems.professionals.splice(indexToRemove, 1);
        updatedItems.professionals_id.splice(indexToRemove, 1);
        updatedItems.is_service.splice(indexToRemove, 1);

        // Update session storage and state
        sessionStorage.setItem("cartItems", JSON.stringify(updatedItems));
        console.log("Item removed successfully.");
      } else {
        console.log("Item not found in cart.");
      }
    }

    // Handle service_id logic (e.g., fetch employees and set search query)
    if (service_id) {
      console.log("Fetching matched product...");

      const matchedProduct = cartItems?.product?.find(
        (product) => product.id === service_id
      );
      const matchedProductName = matchedProduct?.descriptions[0]?.name;

      console.log("Matched product:", matchedProduct);

      // Fetch employees for the matched product after a delay
      setTimeout(() => {
        handleGetEmployees(matchedProduct?.id);
      }, 1000);

      // Set the search query to the matched product's name
      setSearchQuery(matchedProductName);
    }
  };
  const fails = (msg) => {
    const toastId = "otp-error-toast"; // Unique ID for OTP error toasts

    toast(msg, {
      style: {
        background: "#f87171",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "2rem",
        padding: "1rem",
        width: "20dvh",
      },
      position: "top-center",
      autoClose: 8000,
      hideProgressBar: false,
      pauseOnHover: true,
      draggable: true,
      progress: 0,
      theme: "colored",
      transition: Bounce,
      toastId: toastId,
      closeButton: ({ closeToast }) => (
        <button
          className="text-white text-4xl leading-none rounded-full p-2"
          onClick={closeToast}
        >
          ×
        </button>
      ),
    });

    // Reset OTP fields
    setOtp({ otp1: "", otp2: "", otp3: "", otp4: "" });

    // Focus on the first OTP input after resetting
    setTimeout(() => {
      if (otpRefs && otpRefs[0] && otpRefs[0].current) {
        otpRefs[0].current.focus();
      }
    }, 0);
  };

  const Success = (msg) => {
    toast(msg, {
      style: {
        background: "#037d0b",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "2rem",
        padding: "1rem",
        width: "20dvh",
      },
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      pauseOnHover: true,
      draggable: true,
      progress: 0,
      theme: "colored",
      transition: Bounce,
      closeButton: ({ closeToast }) => (
        <button
          className="text-white text-4xl leading-none rounded-full p-2"
          onClick={closeToast}
        >
          ×
        </button>
      ),
    });
  };

  //
  // const bookAppointmentData = useSelector(
  //   (state) => state?.getOrder?.orderDone
  // );
  // const orderID = useSelector((state) => state?.getOrderId?.orderDone?.data);
  // const orderIDStatus = useSelector(
  //   (state) => state?.getOrderId?.orderDone?.status
  // );
  // const orderHavesService = useSelector(
  //   (state) => state?.getOrderId?.orderDone?.have_service
  // );
  // console.log("orderIDssss", orderID);
  // console.log("orderIDStatus", orderIDStatus);
  // console.log("orderHavesService", orderHavesService);
  // const bookAppointmentStatus = bookAppointmentData?.status;
  // console.log("bookAppointment", bookAppointmentData);

  // useEffect(() => {
  //   dispatch(getOrderIdData());
  // }, []);

  // const handleSubmit = async (values) => {
  //   const code = Object.values(values).join("");
  //   const sessionCode = sessionStorage.getItem("code");

  //   if (verifyStatus && code === sessionCode) {
  //     // setShowCode(false);
  //     // setIsShow(true);
  //     setIsLoading(true);

  //     try {
  //       await dispatch(getOrderIdData());
  //       const havesService = sessionStorage.getItem("have_service");

  //       if (havesService !== "false") {
  //         await dispatch(getOrderDoneData());
  //       }
  //       // else {
  //       //   throw new Error("Order ID status is not true");
  //       // }
  //       setIsLoading(false);
  //       // After everything is successful, navigate to payment page
  //       navigate("/payment");
  //     } catch (error) {
  //       console.error("Failed to process order data:", error);
  //       fails(); // Handle errors or failure scenarios
  //     }
  //   } else {
  //     fails(); // OTP verification failed
  //   }
  // };
  const base64ToFile = (base64Data, fileName) => {
    const byteString = atob(base64Data.split(",")[1]); // Decode base64
    const mimeString = base64Data.split(",")[0].split(":")[1].split(";")[0]; // Extract MIME type
    const arrayBuffer = new Uint8Array(byteString.length);

    for (let i = 0; i < byteString.length; i++) {
      arrayBuffer[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([arrayBuffer], { type: mimeString });
    return new File([blob], fileName, { type: mimeString });
  };

  // Example usage:
  // dispatch(varifyCodeData())

  const handleSubmit = async (values) => {
    const otp = `${values.otp1}${values.otp2}${values.otp3}${values.otp4}`; // Format OTP as '1234'
    // console.log("Formatted OTP", otp); // Debugging to verify OTP format

    setIsLoading(true);

    try {
      // Dispatch the verify code action with the formatted OTP and handle the response
      const verifyResponse = await dispatch(varifyCodeData({ otp }));
      const verifyStatus = verifyResponse?.payload?.status; // Assuming payload contains the verification status

      if (phone && verifyStatus === true) {
        // Check for parent location
        if (parentLocation === "/camera") {
          const file = base64ToFile(capturedImage, "captured-image.jpg");
          await dispatch(sendPicture({ image: file }));
          navigate("/"); // Navigate to root
          Success("Image sent successfully");
        } else {
          // Fetch order data first
          const havesService = sessionStorage.getItem("have_service");

          if (havesService !== "false") {
            // Step 1: Get Order Data
            const response = await dispatch(getOrderDoneData());
            console.log("Order API Response:", response);

            // console.log("parentReservationIds", parentReservationIds);
            // const reservationIds = response?.reservationData?.data?.items.map(
            //   (item) => item.id
            // );
            // // console.log(reservationIds);
            // const serviceIds = response?.reservationData?.data?.items.map(
            //   (item) => item.service_id
            // );

            if (
              // !response?.reservationData?.data ||
              !response?.payload?.reservationData?.status
            ) {
              setIsLoading(false);
              goToServicePopup(
                response?.payload?.reservationData?.message ||
                  "There is a service or break event in the same time",
                response?.payload?.reservationData?.data?.service_id,
                response?.payload?.reservationData?.data?.employee_id
              );
              return;
            } else {
              // console.log("insde else");
              const getOrderIdResponse = await dispatch(getOrderIdData());
              const orderID = sessionStorage.getItem("order_id");
              // console.log("Fetched orderID after getOrderIdData:", orderID);
              // console.log("getOrderIdResponse:", getOrderIdResponse);

              if (!orderID) {
                fails("Error processing the order.");
                setIsLoading(false);
              } else {
                const parentReservationIds =
                  response?.payload?.reservationData?.data?.id;
                const updateEcommIdResponse = await dispatch(
                  updateEcommIdThunk({
                    ecomm_order_id: orderID,
                    reservation_id: parentReservationIds,
                  })
                );
                // console.log("updateEcommIdResponse", updateEcommIdResponse);
                if (!updateEcommIdResponse?.payload?.status) {
                  fails(!updateEcommIdResponse?.payload?.message);
                  setIsLoading(false);
                } else {
                  const updateReservationResponse = await dispatch(
                    updateReservation({
                      reservationIds: response?.payload?.reservationIds,
                      serviceIds: response?.payload?.serviceIds,
                      parentReservationId:
                        response?.payload?.parentReservationId,
                      orderID: orderID,
                    })
                  ).unwrap();
                  if (!updateReservationResponse?.status) {
                    fails(!updateReservationResponse?.message);
                    setIsLoading(false);
                  }
                }
              }
            }

            // Step 2: Update Reservation
            // const orderID = sessionStorage.getItem("order_id");
          } else {
            await dispatch(getOrderIdData());
          }

          // Step 3: Fetch Order ID Data at the End

          setIsLoading(false);
          navigate("/doneOrder");
          Success("Order done successfully");
        }
      } else {
        fails("OTP is wrong or expired"); // OTP verification failed
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Failed to process order data:", error);
      fails("Error processing the order."); // Handle errors or failure scenarios
      setIsLoading(false);
    }
  };
  // const handleSubmit = async (values) => {
  //   const otp = `${values.otp1}${values.otp2}${values.otp3}${values.otp4}`; // Format OTP as '1234'
  //   setIsLoading(true);

  //   try {
  //     // Dispatch the verify code action with the formatted OTP and handle the response
  //     const verifyResponse = await dispatch(varifyCodeData({ otp }));
  //     const verifyStatus = verifyResponse?.payload?.status; // Assuming payload contains the verification status

  //     if (phone && verifyStatus === true) {
  //       // Check for parent location
  //       if (parentLocation === "/camera") {
  //         const file = base64ToFile(capturedImage, "captured-image.jpg");
  //         await dispatch(sendPicture({ image: file }));
  //         navigate("/"); // Navigate to root
  //         Success("Image sent successfully");
  //       } else {
  //         // Fetch order data first
  //         const havesService = sessionStorage.getItem("have_service");

  //         if (havesService !== "false") {
  //           let response;
  //           try {
  //             // Step 1: Get Order Data
  //             response = await dispatch(getOrderDoneData()).unwrap();
  //             console.log("Order API Response:", response);
  //             console.log(
  //               "Order API Response service_id: ",
  //               response?.reservationData?.data?.service_id
  //             );
  //           } catch (error) {
  //             console.error("Failed to fetch order data:", error);
  //             // Even if there's an error, continue to the next block
  //             response = {
  //               reservationData: {
  //                 status: false,
  //                 message: "Failed to fetch order data.",
  //               },
  //             };
  //           }

  //           const parentReservationIds = response?.reservationData?.data?.id;
  //           const reservationIds = response?.reservationData?.data?.items?.map(
  //             (item) => item.id
  //           );
  //           const serviceIds = response?.reservationData?.data?.items?.map(
  //             (item) => item.service_id
  //           );

  //           if (!response?.reservationData?.status) {
  //             setIsLoading(false);
  //             goToServicePopup(
  //               response?.reservationData?.message ||
  //                 "There is a service or break event in the same time",
  //               response?.reservationData?.data?.service_id
  //             );
  //             return; // Exit the function early
  //           }

  //           // Continue processing if reservation status is true
  //           const getOrderIdResponse = await dispatch(getOrderIdData());
  //           const orderID = sessionStorage.getItem("order_id");

  //           if (!orderID) {
  //             fails("Error processing the order.");
  //             setIsLoading(false);
  //           } else {
  //             const updateEcommIdResponse = await dispatch(
  //               updateEcommIdThunk({
  //                 ecomm_order_id: orderID,
  //                 reservation_id: parentReservationIds,
  //               })
  //             );
  //             if (!updateEcommIdResponse?.payload?.status) {
  //               fails(!updateEcommIdResponse?.payload?.message);
  //               setIsLoading(false);
  //             } else {
  //               const updateReservationResponse = await dispatch(
  //                 updateReservation({
  //                   reservationIds: response?.reservationIds,
  //                   serviceIds: response?.serviceIds,
  //                   parentReservationId: response?.parentReservationId,
  //                   orderID: orderID,
  //                 })
  //               ).unwrap();
  //               if (!updateReservationResponse?.status) {
  //                 fails(!updateReservationResponse?.message);
  //                 setIsLoading(false);
  //               }
  //             }
  //           }
  //         } else {
  //           await dispatch(getOrderIdData());
  //         }

  //         setIsLoading(false);
  //         navigate("/doneOrder");
  //         Success("Order done successfully");
  //       }
  //     } else {
  //       fails("OTP is wrong or expired"); // OTP verification failed
  //       setIsLoading(false);
  //     }
  //   } catch (error) {
  //     console.error("Failed to process order data:", error);
  //     fails("Error processing the order."); // Handle errors or failure scenarios
  //     setIsLoading(false);
  //   }
  // };
  return (
    <>
      <div>
        {/* Your existing JSX */}
        {showPopup && (
          <AutoNavigatePopup
            message={popupMessage}
            navigateTo="/services"
            delay={10000} // Adjust the delay as needed
          />
        )}
      </div>
      {isLoading && (
        <div
          className={`
        
         fixed w-full h-full top-0 left-0   z-[1000] flex justify-center items-center`}
        >
          <Spinner />
        </div>
      )}

      <VerificationHeader />
      <article
        className="relative flex flex-col justify-center h-[85vh]"
        id="verification"
      >
        <div
          onClick={() => {
            sessionStorage.removeItem("phone");
            sessionStorage.removeItem("code");
            navigate("/phoneVerification", {
              state: { from: location.pathname },
            });
          }}
          className="absolute top-[1dvh] p-[.5dvh] rounded-[1.3dvh] left-[0.6dvh] rtl:left-auto rtl:right-[0.6dvh] cursor-pointer bg-[#0000001A] hover:bg-[#00000021]"
        >
          <BackIcon className={"w-[3dvh] h-[3dvh] rtl:rotate-180"} />
        </div>

        <div className="mx-auto w-2/3 border border-white backdrop-blur-md bg-white/30 rounded-2xl overflow-hidden">
          <h1
            className="text-center text-[#66381a] pb-10 pt-4 text-[20px] sm:text-[44px] md:text-[54px] lg:text-[64px]
           xl:text-[80px] 2xl:text-[94px] 3xl:text-[110px] 4xl:text-[120px] 5xl:text-[130px] 6xl:text-[140px] 7xl:text-[160px] font-semibold"
          >
            Code Verification
          </h1>
          <p
            className="relative text-center text-main font-bold text-[16px] sm:text-[20px] md:text-[26px] lg:text-[36px] 
          xl:text-[44px]  2xl:text-[52px]  3xl:text-[65px] 4xl:text-[75px] 5xl:text-[90px] 6xl:text-[110px] 7xl:text-[120px]"
          >
            {/* <span
              className={` ${
                verifyStatus === true ? "" : "hidden"
              } absolute -top-10 left-1/2 -translate-x-1/2 bg-slate-50 px-20 pt-10 pb-6 text-4xl font-semibold text-main rounded-2xl`}
            > */}
            {/* <span
                // onClick={() => setShowCode(false)}
                className="absolute top-0 left-0 text-start font-bold text-black cursor-pointer"
              >
                <span className="w-[4dvh] h-[4dvh] " loading="lazy">
                  <IoMdClose />
                </span>
              </span> */}
            {/* <span
                className="text-[20px] sm:text-[26px] md:text-[36px] lg:text-[45px] 
                 xl:text-[57px]  2xl:text-[68px] my-4"
              >
                {verificationCode}
              </span> */}
            {/* <span className="flex flex-col pt-5">
                <span
                  className="text-[16px] sm:text-[20px] md:text-[26px] lg:text-[36px] 
                 xl:text-[44px]  2xl:text-[52px] "
                >
                  Verify Code
                </span>
                <span className="text-red-500">{code}</span>
              </span> */}
            {/* </span> */}
            verification code has sent to
          </p>
          <span
            className="mb-8 block w-full text-center text-main font-bold text-[16px] sm:text-[20px] md:text-[26px] lg:text-[36px] 
          xl:text-[44px]  2xl:text-[52px]  3xl:text-[65px] 4xl:text-[75px] 5xl:text-[90px] 6xl:text-[110px] 7xl:text-[120px]"
          >
            {maskPhone(phone)}
          </span>
          <Formik
            initialValues={otp}
            validationSchema={OTBSchema}
            onSubmit={handleSubmit} // Use the handleSubmit function here
            enableReinitialize
          >
            <Form className="flex flex-col gap-[20px] mx-auto w-4/5">
              <div className="flex gap-[14px] md:gap-[24px] lg:gap-[34px] justify-center">
                {["otp1", "otp2", "otp3", "otp4"].map((field, index) => (
                  <div key={index}>
                    <Field
                      name={field}
                      type="text"
                      maxLength="1"
                      className=" w-[90px] h-[70px] md:w-[100px] md:h-[90px]  lg:w-[124px] lg:h-[107px]  2xl:w-[140px] 2xl:h-[120px] 3xl:w-[160px] 3xl:h-[140px] 4xl:w-[180px] 4xl:h-[160px]
                       text-[20px] md:text-[30px] lg:text-[40px] xl:text-[50px]  2xl:text-[58px]  3xl:text-[68px] 4xl:text-[80px] 5xl:text-[90px] 6xl:text-[100px] 7xl:text-[120px] text-center border-2 border-gray-300 rounded-[12px] md:rounded-[16px] lg:rounded-[20px] focus:border-main focus:outline-none"
                      value={otp[field]}
                      innerRef={otpRefs[index]}
                      onChange={(e) => handleOtpChange(e, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                    />
                    <ErrorMessage
                      name={field}
                      component="div"
                      className="text-red-500 text-[16.32px] md:text-[22.32px] lg:text-[30.32px] xl:text-[40px]  2xl:text-[52px]  "
                    />
                  </div>
                ))}
              </div>
              {/* {verifyStatus === false && (
                <span className="text-center text-red-700 text-[16px] md:text-[20px] lg:text-[24px] xl:text-[27px]  2xl:text-[32px]  3xl:text-[37px] 4xl:text-[45px] 5xl:text-[50px] 6xl:text-[60px] 7xl:text-[75px]">
                  ( {verifyMessage} )
                </span>
              )} */}
              {parentLocation === "/camera" ? (
                <button
                  type="submit"
                  className="w-full bg-[#e7ded5] text-main border border-main py-4 my-10 font-bold rounded-[10px] md:rounded-[14px] lg:rounded-[20px] text-[20px] md:text-[24px] lg:text-[30px] xl:text-[40px]  2xl:text-[52px]  3xl:text-[65px] 4xl:text-[75px] 5xl:text-[90px] 6xl:text-[110px] 7xl:text-[120px]"
                >
                  Send image to gallery
                </button>
              ) : (
                <button
                  type="submit"
                  className="w-full bg-[#e7ded5] text-main border border-main py-4 my-10 font-bold rounded-[10px] md:rounded-[14px] lg:rounded-[20px] text-[20px] md:text-[24px] lg:text-[30px] xl:text-[40px]  2xl:text-[52px]  3xl:text-[65px] 4xl:text-[75px] 5xl:text-[90px] 6xl:text-[110px] 7xl:text-[120px]"
                >
                  Confirm
                </button>
              )}
            </Form>
          </Formik>
          <div className="flex flex-col items-center justify-center gap-1 md:text-[25px] lg:text-[40.32px]">
            <p className="text-white font-bold text-[16px] sm:text-[20px] md:text-[26px] lg:text-[36px]  xl:text-[44px]  2xl:text-[52px]  3xl:text-[65px] 4xl:text-[75px] 5xl:text-[90px] 6xl:text-[110px] 7xl:text-[120px]">
              {/* {t("noCode")} */}
              Didn’t receive code?
            </p>
            <button
              onClick={async () => {
                if (timeLeft === 0) {
                  try {
                    // Dispatch the first action and wait for it to complete
                    await dispatch(getCodeData({ firebaseIntegrationFile }));

                    // Wait for 2 seconds before the next dispatch
                    // await new Promise((resolve) => setTimeout(resolve, 500));

                    // Dispatch the second action and wait for it to complete
                    // await dispatch(varifyCodeData());

                    // Only proceed to send the notification if the verification is valid
                    // const verification = sessionStorage.getItem("code");
                    // await dispatch(
                    //   sendNotification({
                    //     verificationCode: verification,
                    //   })
                    // );

                    // Reset the timer
                    setTimeLeft(60);
                  } catch (error) {
                    console.error(
                      "An error occurred during the sequential dispatch process:",
                      error
                    );
                  }
                }
              }}
              disabled={timeLeft > 0}
              className="text-black font-semibold text-[14px] sm:text-[16px] md:text-[20px]
               lg:text-[24px] xl:text-[27px]  2xl:text-[32px]  3xl:text-[37px] 4xl:text-[45px]
                5xl:text-[50px] 6xl:text-[60px] 7xl:text-[75px]"
            >
              {/* {t("resendCode")} */}
              Resend Code ({formatTime(timeLeft)})
            </button>
          </div>
          <div
            onClick={() => setIsShowKeyboard(true)}
            className={`${
              isShowKeyboard ? "hidden" : ""
            } cursor-pointer mx-auto w-fit text-black`}
          >
            <FaRegKeyboard
              className="w-[30px] h-[30px] md:w-[40px] md:h-[40px] lg:w-[50px] lg:h-[50px] xl:w-[60px] 
            xl:h-[60px] 2xl:w-[70px] 2xl:h-[70px] 3xl:w-[80px] 3xl:h-[80px] 4xl:w-[90px] 4xl:h-[90px] 5xl:w-[100px] 
            5xl:h-[100px] 6xl:w-[110px] 6xl:h-[110px] 7xl:w-[120px] 7xl:h-[120px]"
            />
          </div>
          {/* keyboard */}
          <div
            className={`${
              isShowKeyboard ? "" : "hidden"
            } bg-white w-full pb-[1dvh]`}
          >
            <div
              onClick={() => setIsShowKeyboard(false)}
              className="
            w-[8dvh] cursor-pointer ms-[1dvh]  text-[2.2dvh]
            "
              loading="lazy"
            >
              <IoMdClose />
            </div>
            <div
              className={`${
                isShowKeyboard ? "block" : "hidden"
              } grid grid-cols-3 gap-[0.5dvh] my-[0.3dvh] w-full mx-auto`}
            >
              {["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"].map((num) => (
                <button
                  key={num}
                  onClick={() => handleKeyboardClick(num)}
                  className="p-[0.5dvh] bg-gray-300 text-[2dvh] rounded-lg"
                >
                  {num}
                </button>
              ))}
              <button
                onClick={handleDelete}
                className="col-span-2 p-[0.5dvh] bg-main text-white text-[2dvh] rounded-lg"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </article>
    </>
  );
}
